import {useEffect, useState} from 'react';
import {InfoLabel, SegmentLabel, SettingsLabel} from "../../../../config/Config";
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";

import Field from "../../Field";
import Alert from "../../../alert/Alert";
import Loading from "../../../generic/Loading";


const Segment = (props) => {
    const {journey, currentNode} = props
    const [segment, setSegment] = useState()
    const [loading, setLoading] = useState(false)
    const [segments, setSegments] = useState([])
    const [fields, setFields] = useState([])



    const handleSegmentChange = (selected) => {
        if(selected === null){
            setSegment(undefined);
            return;
        }
        checkCurrentSegment(selected)
    }


    const checkCurrentSegment = (current) => {
        if(props?.journey?.Audience?.segments?.length > 0){
            props?.journey?.Audience?.segments.map(item => {
                if(item?._id?.$oid === current?.value){
                    setSegment(item);
                }
            })
        }
    }

    const Information = {
        className: 'alert-primary',
        message  : `As its name suggests, allows you to choose a segment of your audience. `,
        docs     : {
            message: 'For more info, ',
            path   : '/docs/journeys/segment/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }


    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: SegmentLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const ChooseSegment = {
        tab            : 'settings',
        name           : 'id_segment',
        type           : 'select',
        label          : 'Choose a segment',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose a segment',
        required       : true,
        isMulti        : false,
        isSearchable   : true,
        options        : segments,
        node           : currentNode,
        onChange       : handleSegmentChange
    }


    const ChooseFields = {
        tab                : 'settings',
        name               : 'fields',
        type               : 'select',
        label              : 'Choose fields',
        wrapper            : 'form-group',
        className          : 'input-sm',
        classNamePrefix    : 'input-sm',
        placeholder        : 'Choose fields',
        hideSelectedOptions: false,
        required           : false,
        isMulti            : true,
        isSearchable       : true,
        options            : fields,
        node               : currentNode
    }


    const AlertPhone = {
        tab         : 'settings',
        name        : 'alert_email',
        type        : 'text',
        label       : 'Send me an email if the segment does not find contacts',
        wrapper     : 'form-group',
        placeholder : 'Email address',
        node        : currentNode,
    }


    const prepareData = () => {
        let fieldsOptions = [
            {
                label  : 'Audience fields',
                options: []
            },
            {
                label  : 'History fields',
                options: []
            },
        ]

        let segmentsOptions = []
        checkCurrentSegment(currentNode?.data?.form?.tabs?.settings?.fields?.id_segment?.value)

        journey.Audience?.segments && journey.Audience.segments.map((segment) => {
            segmentsOptions.push({value: segment._id.$oid, label: segment.name})
        })

        journey.Audience.fields && journey.Audience.fields.map((field) => {
            if (field.field_target === 'audience') {
                fieldsOptions[0].options.push({value: field._id.$oid, label: field.name})
            }
        })

        setFields(fieldsOptions)
        setSegments(segmentsOptions);

    }


    useEffect(() => {
        setLoading(true)

        prepareData()
        setLoading(false)
    }, [])


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field {...ChooseSegment} />
                                        {segment && <div style={{display: 'block', margin: '30px 8px'}}>
                                            <Field {...AlertPhone} />
                                        </div> }
                                        <Field {...ChooseFields} />
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Segment;